import { render, staticRenderFns } from "./signPad.vue?vue&type=template&id=cc275a38&scoped=true"
import script from "./signPad.vue?vue&type=script&lang=js"
export * from "./signPad.vue?vue&type=script&lang=js"
import style0 from "./signPad.vue?vue&type=style&index=0&id=cc275a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc275a38",
  null
  
)

export default component.exports